import utils from 'utils'

class messageListCtrl {
    constructor($rootScope, $scope, logger, httpRequest, $state, $stateParams) {
        $('body').addClass('leftnav-close')
        $rootScope.leftNavDisabled = true
        $scope.messageData = []
        $scope.resData = {}
        $scope.tiltetype = [
            '销售单审核',
            '红字信息表审核',
            '发票作废申请审核',
            '红票数量预警',
            '作废数量预警',
        ]

        $scope.currentPage = 1
        $scope.maxPage = 1
        const size = 20 // 每页20行

        // 更新未读消息条数 延迟2秒并合并
        $scope.updateMessageCountTask = null

        function updateMessageCount() {
            if (!$scope.updateMessageCountTask) {
                $scope.updateMessageCountTask = setTimeout(() => {
                    $rootScope.$emit('messageStatusChange')
                    $scope.updateMessageCountTask = null
                }, 2000)
            }
        }

        function qryNoticeByUser(num, pageSize) {
            let param = {  
                pageNum: num, 
                pageSize,
                param:{
                    instanceStatus:'0'//未处理消息
                }
            }
            httpRequest.post_getNoticeByUser(param).then((res) => {
                $scope.resData = res.data.value
                $scope.messageData = $scope.resData.list
                $scope.maxPage = $scope.resData.pages
                updateMessageCount()
            })
        }
        qryNoticeByUser($scope.currentPage, size)

        // 返回按钮
        $scope.gobackbtn = function () {
            $state.go($stateParams.lasturl)
        }
        // 全部已读
        $scope.setAllToReaded = function () {
            httpRequest.post_updateUserNoticeRead().then(() => {
                logger.logSuccess('已全部设为已读')
                qryNoticeByUser($scope.currentPage, size)
                $rootScope.userMessage.userNoticeCount = 0
            })
        }
        // 翻页按钮
        $scope.buttonchange = function (num) {
            $scope.currentPage += num
            $scope.currentPage = Math.max($scope.currentPage, 1)
            $scope.currentPage = Math.min($scope.currentPage, $scope.resData.pages)
            qryNoticeByUser($scope.currentPage, size)
        }

        function updateMsgStatus(item) {
            return new Promise((resolve) => {
                if (item.instanceStatus === '0') {
                    httpRequest.setMessageReaded({noticeIds: [item.noticeId]}).then((res) => {
                        $rootScope.userMessage.userNoticeCount -= 1
                        resolve()
                        qryNoticeByUser($scope.currentPage, size)
                    })
                } else {
                    resolve()
                }
            })
        }
        // 右边li内容点击事件
        $scope.itemchange = function (item) {
            updateMsgStatus(item).then(() => {
                if (item.noticeType == 0) {
                    // $state.go("preWarn");//跳转到预警
                } else if (item.noticeType == 1) {
                    $rootScope.leftNavDisabled = false
                    if (item.noticeRefId) {
                        $('body').removeClass('leftnav-close')
                        // $location.path(`/workspace/item/${utils.encode(JSON.stringify({ actionId: item.noticeRefId }))}`).replace()
                        $state.go('workspace.item', {
                            taskId: utils.encode(JSON.stringify({
                                actionId: item.noticeRefId
                            }))
                        })
                    } else {
                        $('body').removeClass('leftnav-close')
                        $state.go('workspace.list')
                    }
                }
            })
        }
    }
}
messageListCtrl.$inject = ['$rootScope', '$scope', 'logger', 'httpRequest', '$state', '$stateParams']
export default messageListCtrl


// WEBPACK FOOTER //
// ./src/app/main/message/messageListCtrl.js